<aside class="sidebar-area">
    <div class="widget widget_search  ">
        <form class="search-form">
            <input type="text" placeholder="Search">
            <button type="submit"><i class="far fa-search"></i></button>
        </form>
    </div>
    <div class="widget widget_categories  ">
        <h3 class="widget_title teko-600">Categories</h3>
        <ul>
            <li>
                <a routerLink="/website-development">Web Developments</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/design">UX/UI Design</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/mobile-development">App Development</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/ai-assisted-integrations">AI Assisted Integrations</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/ios-development">iOS Development</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/logo-design">Logo Design</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/seo-services">SEO Services</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
        </ul>
    </div>
    <div class="widget" *ngIf="blogs && blogs.length > 0">
        <h3 class="widget_title teko-600">Recent Posts</h3>
        <div *ngFor="let blog of blogs" class="recent-post-wrap">
            <div class="recent-post mb-5">
                <div class="media-img">
                    <a routerLink="/latest-news/{{ blog.slug }}">
                        <img [src]="blog.featured_image" (error)="onImageError($event)" alt="{{ blog.title }}"
                            class="blog-feature-thumb" />
                    </a>
                </div>
                <div class="media-body">
                    <div class="recent-post-meta">
                        <a routerLink="/latest-news/{{ blog.slug }}">
                            <i class="fa-solid fa-calendar-days"></i>{{ blog.published_at | date:'dd MMMM yyyy' }}
                        </a>
                    </div>
                    <h4 class="post-title">
                        <a class="text-inherit teko-500" routerLink="/latest-news/{{ blog.slug }}"
                            [innerHTML]="blog.title">
                            {{ blog.title ?? '' }}
                        </a>
                    </h4>
                </div>
            </div>
        </div>
    </div>
    <div class="widget widget_tag_cloud  ">
        <h3 class="widget_title teko-600">Popular Tags</h3>
        <div class="tagcloud">
            <a routerLink="/planning-and-requirement-gathering">Analysis</a>
            <a routerLink="/design">Web Design</a>
            <a routerLink="/website-development">Development</a>
            <a routerLink="/testing-and-review">Testing & Review</a>
            <a routerLink="/deployment">Deployment</a>
            <a routerLink="/maintenance-and-updates">Maintenance and Updates</a>
            <a routerLink="/services">Services</a>
            <a routerLink="/design">UX/UI Design</a>
            <a routerLink="/mobile-development">App Development</a>
        </div>
    </div>
    <div class="widget widget_banner  " data-bg-src="assets/img/bg/widget_banner.jpg">
        <div class="widget-banner position-relative text-center">
            <span class="icon"><i class="fa-solid fa-phone"></i></span>
            <span class="text">Need Help? Call Here</span>
            <a class="phone" href="tel:+918090920216">+91-8090-920216</a>
            <a routerLink="/contact" class="th-btn style6">Get A Quote <i class="fa-light fa-arrow-right-long"></i></a>
        </div>
    </div>
</aside>